<template>
    <h1>Извините, такой страницы нет</h1>
</template>
<script>

export default{
    name: 'ErrorPage',
}
</script>